import React from 'react'
import PropTypes from 'prop-types'
import { INIT_APP_PARAMS } from '../../actions'

const withSiteAndLocale = (Component) => {
  const wrapped = class extends React.Component {
    componentDidMount() {
      this.props.handleAction(INIT_APP_PARAMS, this.props.location.query)
    }

    render() {
      return (
        <Component
          {...this.props}
          {...this.state}
        />
      )
    }
  }

  wrapped.propTypes = {
    handleAction: PropTypes.func,
    location: PropTypes.shape({
      query: PropTypes.object.isRequired,
    }).isRequired,
  }

  wrapped.defaultProps = {
    handleAction: PropTypes.func,
  }

  return wrapped
}

withSiteAndLocale.propTypes = {
  Component: PropTypes.element,
}

withSiteAndLocale.defaultProps = {
  Component: PropTypes.element,
}

export default withSiteAndLocale



// WEBPACK FOOTER //
// ./src/components/hoc/site-and-locale.js